import { useAnalytics } from '@wbk/analytics';
import { Link, useRouter } from '@wbk/config';
import { parseSectionItem } from '@wbk/contentful';
import { WebSection } from '@wbk/contentful/api';
import { Button } from '@wbk/ui';
import { parseSectionUtm } from '@wbk/utils';
import EventCard from '@/components/events/EventCard';
import ScrollTitle from '@/components/ui/ScrollTitle';
import { Carousel } from '@/components/ui/Carousel';
import { getEventRedirectUrl } from '@/utils/redirect';

export default function EventSection({ section }: { section: WebSection }) {
  const { locale } = useRouter();

  const { trackEvent } = useAnalytics();

  const items = section.contentCollection.items;

  return (
    <div className='container-padding container'>
      <section className='container relative px-3 lg:space-y-12 xl:px-0'>
        <div
          id='events'
          className='pointer-events-none invisible absolute inset-x-0 -top-40 -z-10 h-10 w-full'
        />
        <div className='lg:block lg:space-y-12'>
          <div className='flex items-center justify-between'>
            <ScrollTitle title={section.title} />
          </div>

          <div className='space-y-8'>
            <Carousel
              rootClassName='box-border flex mb-10 w-full flex-1 rounded-2xl'
              containerClassName='h-full  gap-4'
              className='w-full'
              options={{
                loop: true,
                active: items.length > 1,
              }}
              autoplay={{
                delay: 5000,
                stopOnMouseEnter: true,
              }}
              dots
            >
              {items.map((item, index) => {
                const parsedItem = parseSectionItem({ item, locale });
                if (!parsedItem) return null;
                const parsed = parsedItem;

                const utm = parseSectionUtm({
                  utm: section.utm,
                  idx: index,
                  id: parsed.id,
                  root: !parsed.href?.includes('?'),
                });

                const redirectInfo = getEventRedirectUrl(
                  item,
                  'slug' in item ? item.slug : '',
                  locale,
                  parsed,
                  utm
                );

                return (
                  <div
                    className='shrink-0 basis-[85%] object-cover p-0 hover:bg-transparent sm:basis-[60%] md:basis-[50%] lg:basis-[40%] xl:basis-[30%]'
                    key={index}
                  >
                    <Button
                      as={Link}
                      href={redirectInfo.href}
                      theme='white'
                      shape='text'
                      className='w-full p-0'
                      key={index}
                      target={redirectInfo.isExternal ? '_blank' : undefined}
                      onClick={() => {
                        trackEvent({
                          event: 'clicked_on_section_item',
                          data: {
                            type: item.__typename,
                            slug: 'slug' in item ? item.slug : '',
                            section: section.id,
                          },
                        });
                      }}
                      rel='noreferrer'
                    >
                      <EventCard
                        key={index}
                        eventType={parsedItem?.eventType}
                        venueName={parsed.title}
                        eventDate={parsed.date || ''}
                        priceFrom={parsed.startingPrice}
                        currency={parsed.currencyCode}
                        image={parsed.image11}
                        // @ts-expect-error -- zone object exists but not typed
                        zoneLogo={parsed?.zone?.zoneLogo}
                        buttonText={parsed?.label || undefined}
                      />
                    </Button>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </section>
    </div>
  );
}
